import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { StorageService } from '@toro/common/libs/toro-storage';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { ConsolidatedPosition } from '@toro/common/shared/models/pos-risk/consolidated-position';
import { FinancePosition } from '@toro/common/shared/models/pos-risk/finance-position';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { GuidedTour, GuidedTourService, Orientation } from 'ngx-guided-tour';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ICheckoutStock } from '../../../../../interfaces/checkout.interface';

@Component({
	selector: 'checkout-header',
	templateUrl: './checkout-header.component.html',
	styleUrls: ['./checkout-header.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CheckoutHeaderComponent implements OnInit {
	@Output('close') public close = new EventEmitter();
	@Input('stock') public stock: ICheckoutStock;

	public consolidatedPosition: ConsolidatedPosition;
	public typeMarketEnum = OrderMarketTypeEnum;
	public disposableSubscriptions: Subscription[] = [];
	public totalGuarantee: number;
	public userCblc: string;
	public finance: FinancePosition;

	public opLimitingTour: GuidedTour = {
		tourId: 'operating-limiting',
		useOrb: false,
		steps: [
			{
				title: 'Garantia disponível',
				selector: '.resume-subtitles',
				content: 'Agora você pode operar em Swing Trade usando a garantia disponível quando não houver saldo suficiente em sua conta corrente.',
				orientation: Orientation.BottomLeft,
				useHighlightPadding: true,
				highlightPadding: 8
			}
		]
	};

	public tooltipGuaranteeDisclaimer: string = `
		<div>
			<p class="pop-content">Esse é o limite que pode ser utilizado para operações em renda variável quando não houver saldo suficiente em sua conta corrente. </p>
			<a class="limit-tooltip-bottom-warning" href="https://blog.toroinvestimentos.com.br/trading/margem-de-garantia-o-que-e/" target="_blank"> Saiba mais sobre Margem de Garantia </a>
		</div>
	`;

	constructor(
		private store: Store<AppState>,
		readonly guidedTourService: GuidedTourService,
		readonly storageService: StorageService,
	) {
		this.bindConsolidatePositionSubscription();
		this.createSubscriptions();
		this.initUserCblcListener();

		if (storageService.local.getItem('showOpLimitingOnboarding') != 'false')
			setTimeout(() => {
				this.guidedTourService.startTour(this.opLimitingTour);
				storageService.local.setItem('showOpLimitingOnboarding', 'false');
			}, 1000);
	}


	public ngOnInit() {
		this.store.dispatch({ type: FinanceActions.getRealtimeFinancePosition });

		this.store.select((store) => store.finance)
			.subscribe((finance) => {
				this.finance = finance.finance;
		});
	}

	public get availableToInvest() {
		if (this.stock.isFuture || this.stock.isDayTrade) {
			return this.consolidatedPosition.totalOperationGuarantee;
		}

		return this.stock.purchase ? this.calculeBalanceByProjectedPosition(this.finance) : this.consolidatedPosition.totalOperationGuarantee;
	}

	public createSubscriptions() {
		this.bindConsolidatePositionSubscription();

		this.totalGuarantee = this.consolidatedPosition.totalOperationGuarantee - Math.abs(this.consolidatedPosition.accountBalance);
	}

	public initUserCblcListener = () => {
		this.store.select((state) => state.authentication.currentUser)
			.filter((data) => !!data && !!data.cblc)
			.first()
			.subscribe((data) => {
				this.userCblc = data.cblc;
			});
	}


	public bindConsolidatePositionSubscription() {
		this.store.select((state) => state.finance.consolidatePosition)
			.pipe(
				filter((consolidatePosition) => !!consolidatePosition))
			.subscribe(consolidatedPosition => this.consolidatedPosition = consolidatedPosition);
	}

	public calculeBalanceByProjectedPosition(financePosition: FinancePosition): number {
		return financePosition.availableOnAccountD0 + this.getProjectedRisk(this.finance);
	}

	private getProjectedRisk(financePosition: FinancePosition): number {
		return financePosition.projectedD1 + financePosition.projectedD2;
	}
}
